import { useCallback, useState } from "react";
import { useEnvironment } from "@aviv-unified-frontend/runtime/environment";
import { BRAND_CONFIGURATION } from "../../../../configs/brands";
export const useShouldLoadCustomBanner = () => {
    const [isDismissed, setIsDismissed] = useState(false);
    const onDismiss = useCallback(() => {
        setIsDismissed(true);
    }, []);
    const { application: { id: applicationId }, } = useEnvironment();
    const output = {
        shouldLoad: false,
        isDismissed,
        onDismiss,
    };
    if (!applicationId)
        return output;
    if ([
        "app_cldp",
        "app_serp",
        "app_serp_map",
        "app_serp_project",
        "app_esfu_estimaLandingPage",
    ].includes(applicationId))
        return output;
    return {
        ...output,
        shouldLoad: Boolean(BRAND_CONFIGURATION.appBanner?.custom?.[applicationId]),
    };
};
